import {
  AsyncResult,
  callActionOrExecute,
  DataServiceQuery,
  IContext,
  IDataServiceRequest,
} from "@msdyn365-commerce/retail-proxy";
import * as AssetsDataServiceEntities from "./AssetsDataServiceEntities.g";

function lTSGetProductAssetsQuery(): DataServiceQuery {
  return new DataServiceQuery();
}

export function lTSGetProductAssetsInput(itemId: string): IDataServiceRequest {
  const query = lTSGetProductAssetsQuery();
  return query.createDataServiceRequestForOperation(
    "LTSGetProductAssets",
    true,
    AssetsDataServiceEntities.LTSGetProductAssetResponseExtensionClass,
    "false",
    {
      bypassCache: "get",
      returnEntity: "AssetsDataServiceEntities.ILTSGetProductAssetResponse",
    },
    {
      itemId: itemId,
    },
  );
}

export function lTSGetProductAssetsAsync(
  context: IContext,
  itemId: string,
): AsyncResult<AssetsDataServiceEntities.ILTSGetProductAssetResponse> {
  const request = lTSGetProductAssetsInput(itemId);
  return callActionOrExecute<
    AssetsDataServiceEntities.ILTSGetProductAssetResponse
  >(request, context.callerContext);
}
